//아이콘
// 제목 -> 2줄까지 고정값 X
// 위치 139px
// 전화 139px
//운영 시간
//브레이크 다임
// 공간 Url
// 출발, 도착 위경도
//공간 VR optional

import { body2, body3, h3, palette } from '@/modules/defines/styles';
import styled, { keyframes } from 'styled-components';

import { Space } from '@/modules/defines/interface';
import chevron_right from '@/assets/icon/chevron-right.svg';
import arrow from '@/assets/icon/arrow-big-right.svg';
import pin from '@/assets/icon/map-pin-filled.svg';
import { Fragment, memo, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import findCategoryIcon from '@/utils/function/getCategoryIcon';
import { logClickSpaceModalButton } from '@/utils/amplitude';

//  위경도
interface SpaceModalProps {
  space: Space | null;
  isOpen: boolean;
  setClose: (value: React.SetStateAction<boolean>) => void;
  handleSelectStart?: () => void;
  handleSelectEnd?: () => void;
}
const SpaceModal = ({
  space,
  setClose,
  isOpen,
  handleSelectEnd,
  handleSelectStart,
}: SpaceModalProps) => {
  const location = useLocation();
  const zoneType = [
    {
      type: 'raon',
      title: '라온존',
    },
    {
      type: 'atti',
      title: '아띠존',
    },
    {
      type: '-',
      title: '-',
    },
  ];

  const findKorName = (type: string) => {
    if (!type) return '정보 없음';
    return zoneType.find((zone) => zone.type === type)?.title;
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    return () => {
      document.body.style.overflow = 'auto';
      document.body.style.touchAction = 'auto';
    };
  }, []);

  if (!space) return null;
  return (
    <BlackGround
      $open={isOpen}
      onClick={() => {
        setClose(false);
      }}
    >
      <Box
        onClick={(e) => {
          e.stopPropagation();
        }}
        $isVisible={isOpen}
      >
        <FlexJustifyBetween>
          <TitleWrapper>
            <img src={findCategoryIcon(space.category)} alt="category" />
            <Title>{space?.title ? space.title : '정보 없음'}</Title>
          </TitleWrapper>
          <img
            onClick={() => {
              setClose(false);
              logClickSpaceModalButton('detail', space.id, space.title);
              window.open(space.link, '_blank');
            }}
            width={20}
            height={20}
            src={chevron_right}
            alt="chevron_right"
          />
        </FlexJustifyBetween>
        <InfoList>
          <InfoListItem>
            <Name>위치</Name>
            <Info>
              {space.floor === '-1' ? 'B1F' : `${space.floor}F`}{' '}
              {findKorName(space.type)}
            </Info>
          </InfoListItem>
          <InfoListItem>
            <Name>전화</Name>
            <Info>{space.phone ? space.phone : '정보 없음'}</Info>
          </InfoListItem>

          {space.time && space.time.includes('/BT') ? (
            <Fragment key="time_info">
              <InfoListItem>
                <Name>운영 시간</Name>
                <Info>{space.time.split('/BT')[0]}</Info>
              </InfoListItem>
              <InfoListItem>
                <Name>브레이크 타임</Name>
                <Info>{space.time.split('/BT')[1].trim()}</Info>
              </InfoListItem>
            </Fragment>
          ) : (
            <InfoListItem>
              <Name>운영 시간</Name>
              <Info>{space.time}</Info>
            </InfoListItem>
          )}
        </InfoList>
        {/* <Hr />
        <FlexJustifyBetween $margin="0.75rem 0 1rem 0">
          <SpaceInfoWrapper>
            <img width={20} height={20} src={cube} alt="공간 둘러보기" />
            공간 VR 둘러보기
          </SpaceInfoWrapper>
          <img width={20} height={20} src={chevron_right} alt="chevron_right" />
        </FlexJustifyBetween> */}
        <FlexJustifyBetween>
          <SmallButton
            to={{
              pathname: '/navi',
            }}
            onClick={() => {
              logClickSpaceModalButton('start', space.id, space.title);
              // alert('출발지로 설정되었습니다.');
              if (location.pathname === '/main') {
                sessionStorage.setItem('start', JSON.stringify(space));
                sessionStorage.removeItem('end');
              }
              if (handleSelectStart) {
                handleSelectStart();
              }
            }}
          >
            <img width={20} height={20} src={arrow} alt="출발" />
            출발
          </SmallButton>
          <SmallButton
            to={{
              pathname: '/navi',
            }}
            onClick={() => {
              logClickSpaceModalButton('end', space.id, space.title);
              // alert('도착지로 설정되었습니다.');
              if (location.pathname === '/main') {
                sessionStorage.setItem('end', JSON.stringify(space));
                sessionStorage.removeItem('start');
              }
              if (handleSelectEnd) {
                handleSelectEnd();
              }
            }}
          >
            <img width={20} height={20} src={pin} alt="도착" />
            도착
          </SmallButton>
        </FlexJustifyBetween>
      </Box>
    </BlackGround>
  );
};

const fadeInUp = keyframes`
  from {
    opacity: 0;
    left: 50%;
    transform:translate(-50%,5px);
  }
  to {
    opacity: 1;
    left: 50%;
    transform: translate(-50%,0);
  }
`;

const fadeOutDown = keyframes`
  from {
    opacity: 1;
    left: 50%;
    transform: translate(-50%,0);
  }
  to {
    opacity: 0;
    left: 50%;
    transform:translate(-50%,5px);
  }
`;

const BlackGround = styled.div<{ $open: boolean }>`
  display: ${(props) => (props.$open ? 'block' : 'none')};
  background: ${palette.opacityBlack40};
  width: 100%;
  height: 100%;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 999;
`;

const SmallButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
  width: 10.3125rem;
  padding: 0.6875rem 3.375rem;
  height: 3rem;
  border-radius: 0.5rem;
  background: white;
  border: 1px solid ${palette.gray300};
  ${body2};
  color: ${palette.primaryBlack950};
  text-decoration: none;
`;
// const Hr = styled.hr`
//   border: 0.5px solid ${palette.gray100};
// `;
const FlexJustifyBetween = styled.div<{ $margin?: string }>`
  display: flex;
  justify-content: space-between;
  margin: ${(props) => props.$margin};
`;

const Box = styled.div<{ $isVisible: boolean }>`
  border-radius: 0.75rem;
  padding: 1.375rem 1.375rem 1.5rem 1.375rem;
  box-shadow: 0px 8px 18px 0px rgba(0, 0, 0, 0.12),
    0px 12px 42px 0px rgba(0, 0, 0, 0.12);
  background: #fff;
  position: fixed;
  bottom: 40px;
  width: 24rem;
  left: 50%;
  transform: translateX(-50%);
  height: auto;
  animation: ${({ $isVisible }) => ($isVisible ? fadeInUp : fadeOutDown)} 0.5s
    ease-out;
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Title = styled.h2`
  ${h3};
  color: #000;
`;

const InfoList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;

  margin-top: 1rem;
  margin-bottom: 0.75rem;
`;

const InfoListItem = styled.li`
  display: flex;
  min-width: 10.4375rem;
  align-items: center;
  gap: 0.25rem;
`;

const Name = styled.span`
  ${body3};
  color: ${palette.primaryBlack950};
`;

const Info = styled.span`
  ${body3};
  color: ${palette.gray700};
  font-weight: 400;
`;
export default memo(SpaceModal);
